import { SettingsIndexDbService } from './settingsIndexDb.service'
import { generateSalt, getDateTime } from '../utilities'
import { v4 as uuidv4 } from 'uuid'

const DEVICE_ID = 'device'

export interface IDeviceInfo {
  id: string
  createDateTime: string
  salt: Uint8Array
  uuid: string
}

export class DeviceInfoService {
  private db: SettingsIndexDbService
  private tableName: string

  constructor() {
    this.db = new SettingsIndexDbService()
    this.tableName = this.db.deviceInfo.name
  }

  async getDeviceInfo(): Promise<IDeviceInfo | undefined | null> {
    return await this.db.get(DEVICE_ID, this.tableName)
  }

  async createOrGet(): Promise<IDeviceInfo> {
    // There can only be one of these and it can't be overwritten
    // This safe-guards against bad calling code
    const alreadyExists = await this.getDeviceInfo()
    if (alreadyExists) {
      return alreadyExists
    }

    const deviceInfo: IDeviceInfo = {
      id: DEVICE_ID,
      createDateTime: getDateTime(),
      salt: generateSalt(),
      uuid: uuidv4(),
    }

    const added = await this.db.addWithKey(deviceInfo, this.tableName, deviceInfo.id)
    if (!added) {
      throw Error('Unable to initialize device info settings')
    }

    return deviceInfo
  }
}
